import { Link, NavLink, useNavigate } from "react-router-dom";
import { useState } from "react";
import { MagnifyingGlass, List, X } from "@phosphor-icons/react";

const CATEGORY_LINKS = [
  { slug: "investing", name: "Investing" },
  { slug: "personal-finance", name: "Personal Finance" },
  { slug: "cryptocurrency", name: "Crypto" },
  { slug: "stock-market", name: "Stocks" },
  { slug: "retirement-planning", name: "Retirement" },
  { slug: "market-analysis", name: "Markets" },
];

const EXTRA_LINKS = [{ to: "/tools", name: "Tools", testid: "tools" }];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const navigate = useNavigate();

  const onSearch = (e) => {
    e.preventDefault();
    if (q.trim().length >= 2) {
      navigate(`/search?q=${encodeURIComponent(q.trim())}`);
      setOpen(false);
      setQ("");
    }
  };

  return (
    <header className="sticky top-0 z-40 border-b border-foreground/15 bg-background/85 backdrop-blur-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            data-testid="site-logo"
            className="flex items-center gap-2"
          >
            <div className="w-8 h-8 border border-foreground bg-foreground text-background grid place-items-center font-display font-black text-lg">
              F
            </div>
            <div className="leading-none">
              <div className="font-display font-black text-xl tracking-tight">
                Finance Topia
              </div>
              <div className="overline text-[9px] mt-0.5">Finance · Investing · Markets</div>
            </div>
          </Link>

          <nav className="hidden lg:flex items-center gap-1">
            {CATEGORY_LINKS.map((c) => (
              <NavLink
                key={c.slug}
                to={`/category/${c.slug}`}
                data-testid={`nav-${c.slug}`}
                className={({ isActive }) =>
                  `px-3 py-2 text-sm font-medium transition-colors duration-200 hover:text-primary ${
                    isActive ? "text-primary" : "text-foreground/80"
                  }`
                }
              >
                {c.name}
              </NavLink>
            ))}
            {EXTRA_LINKS.map((e) => (
              <NavLink
                key={e.to}
                to={e.to}
                data-testid={`nav-${e.testid}`}
                className={({ isActive }) =>
                  `px-3 py-2 text-sm font-bold uppercase tracking-wider transition-colors duration-200 hover:text-primary border-l border-foreground/15 ml-2 ${
                    isActive ? "text-primary" : "text-foreground"
                  }`
                }
              >
                {e.name}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <form
              onSubmit={onSearch}
              className="hidden md:flex items-center border border-foreground/20 h-9 px-3 gap-2 focus-within:border-foreground"
            >
              <MagnifyingGlass size={16} className="text-foreground/60" />
              <input
                data-testid="search-input"
                value={q}
                onChange={(e) => setQ(e.target.value)}
                placeholder="Search articles"
                className="w-40 lg:w-56 bg-transparent outline-none text-sm placeholder:text-foreground/40"
              />
            </form>
            <button
              data-testid="mobile-menu-btn"
              className="lg:hidden p-2 border border-foreground/20"
              onClick={() => setOpen((v) => !v)}
              aria-label="Toggle menu"
            >
              {open ? <X size={18} /> : <List size={18} />}
            </button>
          </div>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-foreground/10 bg-background">
          <div className="max-w-7xl mx-auto px-4 py-4 flex flex-col gap-1">
            <form onSubmit={onSearch} className="flex items-center border border-foreground/20 h-10 px-3 gap-2 mb-2">
              <MagnifyingGlass size={16} />
              <input
                data-testid="mobile-search-input"
                value={q}
                onChange={(e) => setQ(e.target.value)}
                placeholder="Search articles"
                className="flex-1 bg-transparent outline-none text-sm"
              />
            </form>
            {CATEGORY_LINKS.map((c) => (
              <Link
                key={c.slug}
                to={`/category/${c.slug}`}
                data-testid={`mobile-nav-${c.slug}`}
                onClick={() => setOpen(false)}
                className="py-2 text-sm font-medium border-b border-foreground/5 hover:text-primary"
              >
                {c.name}
              </Link>
            ))}
            {EXTRA_LINKS.map((e) => (
              <Link
                key={e.to}
                to={e.to}
                data-testid={`mobile-nav-${e.testid}`}
                onClick={() => setOpen(false)}
                className="py-2 text-sm font-bold uppercase tracking-wider border-b border-foreground/5 hover:text-primary"
              >
                {e.name}
              </Link>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
